var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "XS Icon Menu Dark",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11846"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 22",
    fill: "#666",
    d: "M0 15h20v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 21",
    fill: "#666",
    d: "M0 10h20v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17",
    fill: "#666",
    d: "M0 5h20v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 16",
    fill: "#6cb50d",
    d: "M0 0h20v2H0z"
  }))));
}
export default SvgMenuDark;